import { constants } from '../constants'
import { common } from './common'
import moment from 'moment'
import { strings } from '../context/LanguageContext/strings'

export const promotions = {
    regexTimeValidation: /(^(?:0?[0-9]|1[0-2])[-:][0-5][0-9]\s*[AaPp][Mm]$)/,

    clearStateFields: state => {
        const updatedState = { ...state }
        Object.keys(updatedState).forEach(field => {
            if (
                typeof updatedState[field] === 'object' &&
                updatedState[field] &&
                field !== 'filterState'
            ) {
                const updatedStateField = updatedState[field]
                updatedStateField['value'] = ''
                updatedStateField['list'] = []
                updatedState[field] = updatedStateField
            } else if (field !== 'filterState') {
                updatedState[field] = ''
            }
        })
        return updatedState
    },

    clearAllStateFields: state => {
        //Clear All fields in the filter side menu
        const clearingState = { ...state }
        const filterState = [...clearingState['filterState']]
        filterState.forEach(({ key, type }) => {
            if (clearingState[key]) {
                if (type === 'option') {
                    clearingState[key].isOn = false
                    clearingState[key].isOff = false
                }
                if (type === 'list') {
                    clearingState[key]['value'] = ''
                    clearingState[key]['list'] = []
                }
                if (type !== 'string') {
                    key === 'audienceSize'
                        ? (clearingState[key]['list'] = [0, 0])
                        : (clearingState[key]['list'] = [])
                    if (clearingState[key]['value']) {
                        clearingState[key]['value'] = ''
                    }
                }
            }
        })
        clearingState['startDateError'] = ''
        clearingState['endDateError'] = ''
        clearingState['enableClearAll'] = true
        return clearingState
    },

    listOfTime: () => {
        let startTime = moment(promotions.calcStartTime())
        const endTime = moment(startTime).add(1, 'days')

        const timeList = []
        while (startTime.isBefore(endTime)) {
            timeList.push(common.getFormattedDate(startTime.valueOf(), 'hh:mm a'))
            startTime = moment(startTime).add(30, 'minutes')
        }
        timeList.sort(function (a, b) {
            return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b)
        })
        return timeList
    },

    calcStartTime: () => {
        const ROUNDING = 30 * 60 * 1000
        return moment(Math.ceil(+moment() / ROUNDING) * ROUNDING)
    },

    _QAStatus: qa =>
        qa
            ? strings.SECTION_MANAGE_PROMOTIONS_TABLE_ACTION_QA_DISABLED
            : strings.SECTION_MANAGE_PROMOTIONS_TABLE_ACTION_QA_ENABLED,

    _ProdStatus: prod =>
        prod
            ? strings.SECTION_MANAGE_PROMOTIONS_TABLE_ACTION_PROD_STATUS_UNPUBLISHED
            : strings.SECTION_MANAGE_PROMOTIONS_TABLE_ACTION_PROD_STATUS_PUBLISHED,

    toCommas: value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),

    getStatusValues: (list, env) => {
        const mappedList = []
        if (list.length > 0) {
            const mappedValues =
                env === 'is_live' ? constants.publishStatusMap : constants.publishQAStatusMap
            list.forEach(val => {
                const value = val.split(' ').join('_')
                mappedList.push(mappedValues[value])
            })
        }
        return mappedList
    },

    getRegionsList: (configurations, regions) => {
        const states = configurations
            .map(({ region }) => region && promotions.parsePromoRegions(region, regions))
            .filter(state => state)
        const uniqueStates = new Set([...states])
        return [...uniqueStates.values()]
    },

    getRegionByCode: (regionCode, regions) => {
        const region = regionCode === 'ALL' ? 'National' : regions[regionCode]
        return region ? region : ''
    },

    parsePromoRegions: ({ state, country }, regions) => {
        return state === 'ALL' ? `National (${country})` : regions[state]
    },

    getUniqueAppPlacements: configs => {
        const set = new Set()
        configs.forEach(({ app, placement_location }) => {
            !!placement_location && set.add(app + ' ' + placement_location)
        })
        return [...set.values()]
    },

    prioritizePromosReqPayload: (start, end) => ({
        search: {
            start_date: start,
            end_date: end,
            status: ['scheduled', 'live', 'finished'],
        },
        sort: { start_date: 'asc' },
        size: 250 /* size is a hardcoded value */,
        pageNo: 1,
    }),

    prioritizingPromos: promos => promos.sort((a, b) => a.priority - b.priority),

    isPromoExisted: (schedule, currentDate) => {
        let showPromo = false
        const { repeat_weekly = null } = schedule

        if (!repeat_weekly) {
            showPromo = true
        } else if (repeat_weekly) {
            showPromo =
                repeat_weekly.repeat_day_of_week.find(day => {
                    return day.toLowerCase() === currentDate.format('ddd').toLowerCase()
                }) && true
        }
        return showPromo
    },
    filterPromosById: (promo1, promo2) =>
        promo1.map(promo => {
            const publishedPromo = promo2.find(({ _id }) => _id === promo._id)
            return publishedPromo ? publishedPromo : { ...promo }
        }),
}
